import { AbstractCustomField } from '@/components/Fields/dataObjects/AbstractCustomField'
import { CustomFieldCustomFieldOptionInput, CustomFieldType } from '@/gql/graphql'

export class BooleanField extends AbstractCustomField {
  fieldType: CustomFieldType = CustomFieldType.Boolean

  optionsForGraphQL(): CustomFieldCustomFieldOptionInput[] {
    // Yes/no does not have options
    return []
  }
}
